import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, Self, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { Utils } from '../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { DialogService } from '../../../../services/dialog.service';
import { DatePipe } from '@angular/common';
import { DestroyService } from '../../../../services/destroyservice';
import { ReplaySubject, Subject, take, takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { CreateControllerGroupPopupComponent } from './createcontrollergroup-popup/createcontrollergroup-popup.component';
import { MatSelect } from '@angular/material/select';
import { ControllerSoftwareDetailsDialogComponent } from './controllersoftwaredetails-dialog.component';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'controllersoftwarerelease',
  templateUrl: './controllersoftwarerelease.component.html',
    styleUrls: ['../../../../style/new-generic-styles.component.less',
        '../../../../style/tables/table-add-butt-header-orange.less',
        '../softwarereleases.component.less',
        './controllersoftwarerelease.component.less'],
    providers: [DestroyService],
    standalone: false
})
export class EMTControllerSoftwareRelease implements OnInit, AfterViewInit {
    public dataSource = new MatTableDataSource<any>();
    public modelFileNames: { [key: number]: string } = {}; 
    @ViewChild(MatTable) objTable!: MatTable<any>;
    @ViewChild(MatSort) sort!: MatSort;

    CSRForm!: FormGroup;
    genType: number = 0;
    originalSoftwareReleases: EMTControllerSoftwareReleaseItem[] = [];
    modifiedSoftwareReleases: EMTControllerSoftwareReleaseItem[] = [];
    newSoftwareReleases: EMTControllerSoftwareReleaseItem[] = [];
    isCallSucceed: number = 0;
    subscriptionStage: any;
    forbiddenchars = ['/', '\\', ':', '*', '?', '<', '>', '|', '"'];
    availableGlobalControllerGroups: EMTGlobalControllerGroup[] = [];
    @Output() controllerSoftwareEvent = new EventEmitter<EMTControllerSoftwareReleaseItem[]>();
    filterControl: FormControl = new FormControl();
    public filteredControllerGroups: ReplaySubject<EMTGlobalControllerGroup[]> = new ReplaySubject<EMTGlobalControllerGroup[]>(1);
    @ViewChild('compatibilitySelect') compatibilitySelect!: MatSelect;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private _formBuilder: FormBuilder,
        private toastrService: ToastrService,
        public defaults: DefaultValuesService,
        private confimDialog: DialogService,
        public datePipe: DatePipe,
        @Self() private readonly destroy$: DestroyService,
        private cdr: ChangeDetectorRef,
        private dialogForm: MatDialog) {
        this.confimDialog.tthis = this;
    }
    @Input() availableFamilyCodes: FamilyCode[] = [];
    @Input() availableProductUsages: EMTProductUsageItem[] = [];
    @Input() availableLanguages: Language[] = [];
    @Input() isContractSpecific: boolean = false;

    columnsToDisplay = ["softwareversion", "releasename", "agentversion", "familycode", "productusage", "releasedate", "comment", "compatibility", "isCompatibleOta2", "action"];

    ngOnInit(): void {
        this.subscriptionStage = this.defaults.stageMessageChanges$.pipe(takeUntil(this.destroy$)).subscribe(() => { this.getSoftwareReleases(); this.getGlobalControllerGroups() });
        this.genType = 0;
        this.CSRForm = this._formBuilder.group({
            CSRRows: this._formBuilder.array([])
        });
        this.getSoftwareReleases();
        this.getGlobalControllerGroups();
        this.filterControl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterControllerGroups();
            });
    }

    ngAfterViewInit() {
        this.setInitialValue();

        this.dataSource.sortData = (data, sort) => {
            if (!sort.active || sort.direction === '') {
                return data;
            }
            const isAsc = sort.direction === 'asc';
            return data.slice().sort((a, b) => {
                switch (sort.active) {
                    case 'softwareversion':
                        return (a.softwareVersion || '').localeCompare(b.softwareVersion || '') * (isAsc ? 1 : -1);
                    case 'agentversion':
                        return (a.tdcAgentVersion || '').localeCompare(b.tdcAgentVersion || '') * (isAsc ? 1 : -1);
                    case 'familycode':
                        const labelA = this.getFamilyCodeText(a.familyCodeId || -1) || '';
                        const labelB = this.getFamilyCodeText(b.familyCodeId || -1) || '';
                        return labelA.localeCompare(labelB) * (isAsc ? 1 : -1);
                    case 'productusage':
                        const prodA = this.getProductUsageText(a.productUsageId || -1) || '';
                        const prodB = this.getProductUsageText(b.productUsageId || -1) || '';
                        return prodA.localeCompare(prodB) * (isAsc ? 1 : -1);
                    case 'releasedate':
                        return ((a.releaseDate ? new Date(a.releaseDate).getTime() : 0) - (b.releaseDate ? new Date(b.releaseDate).getTime() : 0)) * (isAsc ? 1 : -1);
                    case 'releasename':
                        return (a.releaseName || '').localeCompare(b.releaseName || '') * (isAsc ? 1 : -1);
                    case 'comment':
                        return (a.comment || '').localeCompare(b.comment || '') * (isAsc ? 1 : -1);
                    case 'compatibility':
                        const compA = this.getCompatibilityText(a.globalControllerGroupId || -1) || '';
                        const compB = this.getCompatibilityText(b.globalControllerGroupId || -1) || '';
                        return compA.localeCompare(compB) * (isAsc ? 1 : -1);
                    default:
                        return 0;
                }
            });
        };
        this.dataSource.sort = this.sort;
    }
   
    protected _onDestroy = new Subject<void>();

    ngOnDestroy(): void {
        this._onDestroy.next();
        this.subscriptionStage.unsubscribe();
        this.destroy$.next();
        this.destroy$.complete();
        this.confimDialog.tthis = null;
        this.controllerSoftwareEvent.complete();
        this._onDestroy.complete();
    }

    onCommentChange(value: string, element: any) {
        element.comment = value;
    }

    onReleaseNameChange(value: string, element: any) {
        element.releaseName = value;
    }

    getSoftwareReleases() {
        Utils.httpGetEMTControllerSoftwareReleases(
            this.http,
            this.baseUrl,
            this.isContractSpecific,
            this,
            function (tthis: EMTControllerSoftwareRelease, result: EMTControllerSoftwareReleases) {
                tthis.originalSoftwareReleases = result.releasesList;
                tthis.modelFileNames = result.modelFileNames || {};
                tthis.mapDataToForm(tthis.originalSoftwareReleases);
                tthis.controllerSoftwareEvent.emit(tthis.originalSoftwareReleases);
            }
        );
    }
    
    mapDataToForm(data) {
        this.CSRForm = this._formBuilder.group({
            CSRRows: this._formBuilder.array([])
        });
        this.CSRForm = this._formBuilder.group({
            CSRRows: this._formBuilder.array(data.map((val, index) => this._formBuilder.group({
                controllerSoftwareVersionID: new FormControl(val.controllerSoftwareVersionID),
                softwareVersion: new FormControl(val.softwareVersion),
                familyCodeId: new FormControl(val.familyCodeId ?? -1),
                productUsageId: new FormControl(val.productUsageId ?? -1),
                tdcAgentVersion: new FormControl(val.tdcAgentVersion),
                controllerSoftwareVersion: new FormControl(val.controllerSoftwareVersion),
                comment: new FormControl(val.comment),
                softwareFileName: new FormControl(val.softwareFileName),
                softwareFile: new FormControl(val.softwareFile ?? null),
                releaseDate: new FormControl(val.releaseDate != null ? new Date(val.releaseDate) : ""),
                releaseName: new FormControl(val.releaseName),
                isOpenOverlay: new FormControl(false),
                isEditable: new FormControl(true),
                isNewRow: new FormControl(false),
                action: new FormControl('existingRecord'),
                textAreaId: new FormControl(this.getTextAreaId(index)),
                maxCommentLength: new FormControl(2000),
                modifUser: new FormControl(val.modifUser),
                globalControllerGroupId: new FormControl(val.globalControllerGroupId ?? -1),
                isCompatibleOta2: new FormControl(val.isCompatibleOta2 ?? false),
                modelFileId: new FormControl(val.modelFileId ?? null),
                modelFileName: new FormControl(this.modelFileNames[val.modelFileId] || ''),
                modelFileCreatedByUser: new FormControl(val.modelFileCreatedByUser || ''),
                modelFileChangedByUser: new FormControl(val.modelFileChangedByUser || ''),
                modelFileCreatedAtUtc: new FormControl(val.modelFileCreatedAtUtc || null),
                modelFileChangedAtUtc: new FormControl(val.modelFileChangedAtUtc || null),
                modelFilePath: new FormControl(val.modelFilePath || ''),
                modelFileReleaseName: new FormControl(val.modelFileReleaseName || ''),
                availableReleaseNotes: this._formBuilder.array(
                    (val.releaseNotes ?? []).map(note =>
                        this._formBuilder.group({
                            softwareReleaseNotesId: new FormControl(note.softwareReleaseNotesId),
                            softwareReleaseId: new FormControl(note.softwareReleaseId),
                            language: new FormControl(note.language),
                            fileName: new FormControl(note.fileName),
                            isEnabled: new FormControl(note.isEnabled),
                            createdByUser: new FormControl(note.createdByUser),
                            changedAtUtc: new FormControl(note.changedAtUtc),
                            changedByUser: new FormControl(note.changedByUser),
                            createdAtUtc: new FormControl(note.createdAtUtc)
                        })
                    )
                ),
            })
            )) //end of fb array
        }); // end of form group cretation
        this.dataSource.data = (this.CSRForm.get('CSRRows') as FormArray).value;
    }

    initCSRForm(index: number): FormGroup {
        return this._formBuilder.group({
            softwareVersion: new FormControl(`0.0.${this.genType}`),
            tdcAgentVersion: new FormControl(`AG_0.0.${this.genType}`),
            controllerSoftwareVersion: new FormControl(`GC_0.0.${this.genType++}`),
            controllerSoftwareVersionID: new FormControl(-1),
            familyCodeId: new FormControl(-1),
            productUsageId: new FormControl(-1),
            comment: new FormControl(''),
            softwareFileName: new FormControl(''),
            releaseName: new FormControl(''),
            releaseDate: new FormControl(),
            action: new FormControl('newRecord'),           
            isEditable: new FormControl(false),
            isNewRow: new FormControl(true),
            isOpenOverlay: new FormControl(false),
            softwareFile: new FormControl(null),
            textAreaId: new FormControl(this.getTextAreaId(index)),
            maxCommentLength: new FormControl(2000),
            modifUser: new FormControl(''),
            globalControllerGroupId: new FormControl(-1),
            isCompatibleOta2: new FormControl(false),
        });
    }

    get csrRows(): FormArray {
        return this.CSRForm.get('CSRRows') as FormArray;
    }

    getCSRRowFormGroup(id: number): FormGroup | any {
        const index = this.csrRows.controls.findIndex(
            (group: any) => group.get('controllerSoftwareVersionID')?.value === id
        );
        return index !== -1 ? this.csrRows.at(index) as FormGroup : null;
    }

    addNewRow() {
        const tempFormGroup = this.initCSRForm(0);
        this.showDetails(tempFormGroup, null);
    }

    getFamilyCodeText(familyCodeId: number) {
        let famcode = this.availableFamilyCodes?.find(x => x.familyCodeId === familyCodeId);
        if (famcode)
            return `${famcode.familyCode} - ${famcode.familyCodeName}`;
        else
            return "---";
    }

    getProductUsageText(productusageId: number) {
        let prodUsage = this.availableProductUsages?.find(x => x.productUsageID === productusageId);
        if (prodUsage)
            return prodUsage.name;
        else
            return "---";
    }

    resetRow(i) {
        if (this.CSRForm.value.CSRRows[i]?.isNewRow)
            this.deleteRow(i);
        else {            
            this.updateFormFeature(i);
            this.CSRForm.value.CSRRows[i].isEditable = true;
        }       
    }

    deleteRow(i) {
        const control = this.CSRForm.get('CSRRows') as FormArray;
        control.removeAt(i);
        this.dataSource.data = control.value;
        this.refreshTable();
    }

    updateFormFeature(index) {
        const formGroup = this.getCSRRowFormGroup(index);
        var updated = this.originalSoftwareReleases.find(s => s.controllerSoftwareVersionID == this.CSRForm.value.CSRRows[index]?.controllerSoftwareVersionID);
        formGroup.patchValue({ softwareVersion: updated?.softwareVersion });
        formGroup.patchValue({ tdcAgentVersion: updated?.tdcAgentVersion });
        formGroup.patchValue({ controllerSoftwareVersion: updated?.controllerSoftwareVersion });
        formGroup.patchValue({ familyCodeId: updated?.familyCodeId ?? -1 });
        formGroup.patchValue({ productUsageId: updated?.productUsageId ?? -1 });
        formGroup.patchValue({ comment: updated?.comment });
        formGroup.patchValue({ softwareFilename: updated?.softwareFileName });
        formGroup.patchValue({ softwareFile: null });
        formGroup.patchValue({ releaseDate: updated?.releaseDate ?? "" });
        formGroup.patchValue({ releaseName: updated?.releaseName?? "" });
    }

    getIndexByID(id: number): number {
        const arr = this.CSRForm.get('CSRRows') as FormArray;
        return arr.value.findIndex((row: any) => row.controllerSoftwareVersionID === id);
    }

    editRowByID(id: number) {
        const arr = this.CSRForm.get('CSRRows') as FormArray;
        const idx = this.getIndexByID(id);

        if (idx !== -1) {
            arr.at(idx).get('isEditable')?.setValue(false);
            this.dataSource.data = arr.value;
        }
    }

    resetRowByID(id: number) {
        const arr = this.CSRForm.get('CSRRows') as FormArray;
        const idx = this.getIndexByID(id);
        if (idx !== -1) {
            const isNewRow = arr.at(idx).get('isNewRow')?.value;
            if (isNewRow) {
                arr.removeAt(idx);
            } else {
                const original = this.originalSoftwareReleases.find(
                    s => s.controllerSoftwareVersionID === id
                );
                if (original) {
                    arr.at(idx).patchValue({
                        softwareVersion: original.softwareVersion,
                        tdcAgentVersion: original.tdcAgentVersion,
                        controllerSoftwareVersion: original.controllerSoftwareVersion,
                        controllerSoftwareVersionID: original.controllerSoftwareVersionID,
                        productUsageId: original.productUsageId ?? -1,
                        familyCodeId: original.familyCodeId ?? -1,
                        releaseDate: original.releaseDate != null ? new Date(original.releaseDate) : "",
                        releaseName: original.releaseName,
                        softwareFileName: original.softwareFileName,
                        softwareFile: original.softwareFile ?? null,
                        comment: original.comment,
                        compatibility: original.globalControllerGroupId,
                        isCompatibleOta2: original.isCompatibleOta2 ?? false,
                    });
                }
                arr.at(idx).get('isEditable')?.setValue(true);
            }
            this.dataSource.data = arr.value;
        }
    }

    refreshTable() {
        this.objTable.renderRows();
    }

    onSave() {
        if (this.anyChange()) {
            
            let formData: FormData = new FormData();
            this.modifiedSoftwareReleases.forEach((val) => {
                formData.append(val.fileUploadId, val.softwareFile);
            });
            this.newSoftwareReleases.forEach((val) => {
                formData.append(val.fileUploadId, val.softwareFile);
            });  
            let releasesChanges = { 'modifiedReleases': this.modifiedSoftwareReleases, 'newReleases': this.newSoftwareReleases }

            formData.append('releasesChanges', JSON.stringify(releasesChanges)); 

            Utils.httpUpdateControllerSoftwareReleases(
                this.http
                , this.baseUrl
                , formData
                , this
                , function (tthis: EMTControllerSoftwareRelease, result: UpsertSoftwareReleaseResponseDto) {
                    if (result.error) {
                        tthis.isCallSucceed = -1;
                    } else {
                        tthis.isCallSucceed = 1;
                    }
                    if (result?.error && result.errorMssg) {
                        tthis.confimDialog.showErrorDialog({
                            'error':
                            {
                                'message': result.errorMssg
                            }
                        })
                    }
                    tthis.getSoftwareReleases();
                    tthis.funcNotify();
                }
            )
        }
        
    }

    anyChange() {
        this.mapFormToData();
        return this.modifiedSoftwareReleases?.length > 0 || this.newSoftwareReleases?.length > 0;
    }

    mapFormToData() {
        this.modifiedSoftwareReleases = this.CSRForm.get('CSRRows')?.value.filter(row => !row.isNewRow
            && !row.isEditable
            && row.familyCodeId !== -1
            && row.softwareVersion !== "" && row.softwareVersion.length <= 50
            && row.tdcAgentVersion !== "" && row.tdcAgentVersion.length <= 10
            && row.controllerSoftwareVersion !== "" && row.controllerSoftwareVersion.length <= 10
            && (row.comment != null ? row.comment.length <= 2000 : true)
        );
        this.newSoftwareReleases = this.CSRForm.get('CSRRows')?.value.filter(row => row.isNewRow
            && row.familyCodeId !== -1
            && row.softwareVersion !== "" && row.softwareVersion.length <= 50
            && row.tdcAgentVersion !== "" && row.tdcAgentVersion.length <= 10
            && row.controllerSoftwareVersion !== "" && row.controllerSoftwareVersion.length <= 10
            && (row.comment != null ? row.comment.length <= 2000 : true)
            && row.softwareFile != null
        );
    }

    getTextAreaId(index) {
        return `tArea_${index}`;
    }

    getFileUploadId(index) {
        return `fu_${index}`;
    }

    funcNotify() {
        if (this.isCallSucceed === 1) {
            this.toastrService.success('Save request successfully sent!');
        }
        else if (this.isCallSucceed === -1) {
            this.toastrService.error('Save action could not be performed. Please, contact with administrator');
        }
    }

    checkInput(event) {       
        if (this.forbiddenchars.some(x => x === event.key))
            event.preventDefault();        
    }

    getDateUTCChange(element, event) {
        let utcDate = Utils.dateUTCchange(event);
        element.releaseDate = utcDate;
    }

    getGlobalControllerGroups() {
        Utils.httpGetEMTGlobalControllerGroups(
            this.http,
            this.baseUrl,
            this,
            function (tthis: EMTControllerSoftwareRelease, result: EMTGlobalControllerGroup[]) {
                tthis.availableGlobalControllerGroups = result;
                tthis.filteredControllerGroups.next(result);
            }
        );
    }

    getCompatibilityText(globalControllerGroupId: number) {
        let globalControllerGroup = this.availableGlobalControllerGroups.find(x => x.globalControllerGroupId === globalControllerGroupId);
        if (globalControllerGroup)
            return globalControllerGroup.globalControllerGroupName;
        else
            return "---";
    }

    openCreateCompatibilityDialog(softwareVersionId: number) {
        const dialog = this.dialogForm.open(CreateControllerGroupPopupComponent, {
            panelClass: ['custom-mat-dialog_v2', 'dialogNgselect'],
            disableClose: true,
            data: {
                softwareVersionId: softwareVersionId,
                refreshParent: () => {
                    this.getSoftwareReleases();
                    this.getGlobalControllerGroups();
                }
            },
        });
    }

    protected setInitialValue() {
        this.filteredControllerGroups
            .pipe(take(1), takeUntil(this._onDestroy))
            .subscribe(() => {
                // Check if compatibilitySelect exists before setting compareWith
                if (this.compatibilitySelect) {
                    this.compatibilitySelect.compareWith = (a: EMTGlobalControllerGroup, b: EMTGlobalControllerGroup) => a && b && a.globalControllerGroupId === b.globalControllerGroupId;
                }
            });
    }


    protected filterControllerGroups() {
        if (!this.availableGlobalControllerGroups) {
            return;
        }
        // get the search keyword
        let search = this.filterControl.value;
        if (!search) {
            this.filteredControllerGroups.next(this.availableGlobalControllerGroups.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        this.filteredControllerGroups.next(
            this.availableGlobalControllerGroups.filter(cg => cg.globalControllerGroupName.toLowerCase().indexOf(search) > -1)
        );
    }

    showDetails(formGroup: FormGroup, i: number | null): void {
        const dialogRef = this.dialogForm.open(ControllerSoftwareDetailsDialogComponent, {
            height: 'auto',
            width: '950px',
            data: {
                softwareReleaseForm: formGroup,
                availableFamilyCodes: this.availableFamilyCodes,
                availableProductUsages: this.availableProductUsages,
                fileUploadId: this.getFileUploadId(i ?? 0),
                availableLanguages: this.availableLanguages,
                isContractSpecific: this.isContractSpecific
            },
            panelClass: 'details-dialog-panel',
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result?.errorMssg) {
                this.confimDialog.showErrorDialog({
                    'error':
                    {
                        'message': result.errorMssg
                    }
                });
            }
            if (result) {
                if (result.canceled) {
                    if (result.updatedReleaseNotes && result.updatedReleaseNotes.length > 0) {
                        const releaseNotesArray = new FormArray(
                            result.updatedReleaseNotes.map(note =>
                                this._formBuilder.group({
                                    softwareReleaseNotesId: [note.softwareReleaseNotesId],
                                    softwareReleaseId: [note.softwareReleaseId],
                                    language: [note.language],
                                    fileName: [note.fileName],
                                    isEnabled: [note.isEnabled],
                                    createdByUser: [note.createdByUser],
                                    createdAtUtc: [note.createdAtUtc],
                                    changedAtUtc: [note.changedAtUtc],
                                    changedByUser: [note.changedByUser],
                                    file: [null]
                                })
                            )
                        );

                        // Replace the old FormArray with the new one so the UI refreshes
                        const csrRowsArray = this.CSRForm.get('CSRRows') as FormArray;
                        const rowFormGroup = csrRowsArray.at(i ?? 0) as FormGroup;
                        rowFormGroup.setControl('availableReleaseNotes', releaseNotesArray);
                        rowFormGroup.updateValueAndValidity();
                    }
                }
                else {
                    if (result.success) {
                        this.isCallSucceed = 1;
                    } else {
                        this.isCallSucceed = -1;
                    }
                    this.funcNotify();
                    this.getSoftwareReleases();
                }
            }
        });
    }       
}
